import { buildRoute } from '@direct-frontend/modules-router';

export const promotionRoute = buildRoute('/promotion');
